import React from 'react';
import { FaWhatsapp } from "react-icons/fa";

export const WhatsAppButton = ({ text, variant = 'floating' }) => {
  const defaultMessage = "Hello%20Indotravelista,%20I%20would%20like%20to%20inquire%20about%20a%20journey.";
  const whatsappUrl = `https://wa.me/6281517118799?text=${text || defaultMessage}`;

  if (variant === 'floating') {
    return (
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '32px',
          right: '32px',
          width: '60px',
          height: '60px',
          background: '#25D366',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
          zIndex: 1000,
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'pointer'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(37, 211, 102, 0.6)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.4)';
        }}
      >
        <FaWhatsapp size={28} color="white" fill="white" />
      </a>
    );
  }

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="btn-primary"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        background: '#25D366',
        border: 'none',
        textDecoration: 'none'
      }}
    >
      <FaWhatsapp size={18} />
      WhatsApp Us
    </a>
  );
};
